/* eslint-disable no-empty */

import { getLoan, getLoanTypes, getLoanDefaults } from '@/services/loans.service';

import { redirectNotFound } from '@/utils/errorRedirect';

const Model = {
  namespace: 'loanDetail',
  state: {
    loan: null,
    defaults: null,

    loanTypes: [],
  },

  effects: {
    *fetchLoan({ payload }, { call, put }) {
      try {
        const response = yield call(getLoan, payload.id);

        yield put({
          type: 'show',
          payload: { loan: response },
        });
      } catch (error) {
        redirectNotFound(error);
      }
    },

    *fetchLoanTypes(_, { call, put }) {
      try {
        const response = yield call(getLoanTypes);
        yield put({
          type: 'show',
          payload: { loanTypes: response },
        });
      } catch (error) {
        redirectNotFound(error);
      }
    },

    *fetchLoanDefaults(_, { call, put }) {
      const defaults = yield call(getLoanDefaults);
      yield put({
        type: 'show',
        payload: { defaults },
      });
    },
  },

  reducers: {
    show(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
export default Model;
